import { v4 as uuidv4 } from "uuid";

const KEY = "sifaris_device_uuid";

export async function getStableDeviceId() {
  let saved = localStorage.getItem(KEY);

  if (saved) return saved;

  const generated = uuidv4();
  localStorage.setItem(KEY, generated);
  return generated;
}